import React, { useEffect, useState } from "react";
import DashboardContainer from "../../../Dashboard_en/DashboardContainer";
import DashboardContainerHeader from "../../../Dashboard_en/Components/DashboardContainerHeader/DashboardContainerHeader";
import TextInput from "../../../Dashboard_en/Components/Inputs/TextInput/TextInput";
import TextAreaInput from "../../../Dashboard_en/Components/Inputs/TextAreaInput/TextAreaInput";
import { useNavigate, useParams } from "react-router-dom";
import ApiName from "../../../ApiName";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { motion } from "framer-motion";
import axios from "axios";

const updatePaint = async (id, navigate, categoryId, subCategoryId) => {
  confirmAlert({
    title: "Confirmation",
    message: "Are you sure you want to proceed?",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          try {
            await axios.patch(ApiName + "/Paint/" + id, {
              paintName: document.getElementById("paintName").value,
              paintDesc: document.getElementById("paintDesc").value,
              paintSpecs: document.getElementById("paintSpecs").value,
              paintSellURL: document.getElementById("paintSellURL").value,
              paintSmallDesc: document.getElementById("paintSmallDesc").value,
              categoryId: categoryId ? parseInt(categoryId) : null,
              subCategoryId: subCategoryId ? parseInt(subCategoryId) : null,
            }, {
              headers: {
                Authorization: localStorage.authToken,
                "Content-Type": "application/json",
              }
            });
            toast.success("Paint updated successfully!");
            navigate("/admin/paints");
          } catch (error) {
            toast.warning("There was a problem updating the paint!");
          }
        }
      },
      {
        label: "No",
        onClick: () => {}
      }
    ]
  });
};

const AdminEditPaint = () => {
  const [state, setState] = useState({
    paint: null,
  });
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const loadDetails = async () => {
      try {
        const response = await axios.get(ApiName + "/Paint/" + id);
        setState({ paint: response.data.paint });
      } catch (error) {
        console.log("Failed to load the paint details");
        navigate("/admin/paints");
      }
    };
    
    const fetchCategories = async () => {
      try {
        const response = await axios.get(ApiName + "/Category");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };

    loadDetails();
    fetchCategories();
  }, [id, navigate]);

  // Update category and subcategory state when paint loads
  useEffect(() => {
    if (state.paint) {
      if (state.paint.categoryId) setCategoryId(state.paint.categoryId.toString());
      if (state.paint.subCategoryId) setSubCategoryId(state.paint.subCategoryId.toString());
    }
  }, [state.paint]);

  const selectedCategoryObj = categories.find(c => c.id.toString() === categoryId);

  return (
    <motion.div
      initial={{ opacity: 0, transition: { duration: 0.1 } }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.1 } }}
      className="w-full"
    >
      <DashboardContainer>
        <DashboardContainerHeader
          classNames={"text-zinc-900"}
          text="Edit Paint"
        />
        {state.paint != null ? (
          <div className="px-5 py-5">
            <TextInput
              value={state.paint.paintName || ""}
              label="Name"
              id="paintName"
            />
            <TextInput
              value={state.paint.paintSmallDesc || ""}
              label="Small Description"
              id="paintSmallDesc"
            />
            <TextInput
              value={state.paint.paintSellURL || ""}
              label="Sale URL"
              id="paintSellURL"
            />
            <TextAreaInput
              value={state.paint.paintDesc || ""}
              label="Description"
              id="paintDesc"
            />
            <TextAreaInput
              value={state.paint.paintSpecs || ""}
              label="Specifications"
              id="paintSpecs"
            />
            <div className="flex flex-col mb-4">
              <label className="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">Category</label>
              <select
                value={categoryId}
                onChange={(e) => {
                  setCategoryId(e.target.value);
                  setSubCategoryId("");
                }}
                className="p-2 border border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600 dark:text-white"
              >
                <option value="">Select a Category</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            {categoryId && selectedCategoryObj && selectedCategoryObj.subCategories && selectedCategoryObj.subCategories.length > 0 && (
              <div className="flex flex-col mb-4">
                <label className="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">SubCategory</label>
                <select
                  value={subCategoryId}
                  onChange={(e) => setSubCategoryId(e.target.value)}
                  className="p-2 border border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                >
                  <option value="">Select a SubCategory</option>
                  {selectedCategoryObj.subCategories.map((sub) => (
                    <option key={sub.id} value={sub.id}>{sub.name}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="py-3"></div>
            <button 
              onClick={() => updatePaint(id, navigate, categoryId, subCategoryId)} 
              className="px-4 py-2 mt-4 text-white bg-zinc-900 rounded hover:bg-zinc-700 disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors"
            >
              Submit
            </button>
          </div>
        ) : null}
      </DashboardContainer>
    </motion.div>
  );
};

export default AdminEditPaint;
